<template>
  <div>
    <b-card
      no-body
    >
      <div class="m-2">

        <!-- Table Top -->
        <b-row>
          <!-- Search -->
          <b-col
            cols="12"
          >
            <div class="d-flex align-items-center justify-content-end">
              <v-select
                v-model="statusFilter"
                :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
                :options="statusOptions"
                style="text-transform: capitalize"
                class="status-filter-select"
                :placeholder="$t('gig_page.select_status')"
              >
                <template #selected-option="{ label }">
                  <span class="text-truncate overflow-hidden">
                    {{ label }}
                  </span>
                </template>
              </v-select>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refRequestListTable"
        :items="fetchRequests"
        :fields="tableColumns"
        :empty-text="$t('no_matching_records')"
        show-empty
        responsive
        class="position-relative"
      >
        <!-- Column: createdAt -->
        <template #cell(createdAt)="data">
          <span
            class="font-weight-bold"
          >
            {{ typeof(data.value) === 'object' ? data.value.toDate().toLocaleDateString('fi') : '' }}
          </span>
        </template>

        <!-- Column: name -->
        <template #cell(name)="data">
          <b-link
            :to="{ name: 'apps-requests-view', params: { id: data.item.id } }"
            class="font-weight-bold d-block text-nowrap"
            style="text-transform: capitalize"
          >
            {{ data.value }}
          </b-link>
        </template>

        <!-- Column: ticketId -->
        <template #cell(ticketId)="data">
          <b-link
            class="font-weight-bold capitalize"
            :href="`https://hoiwa.zendesk.com/agent/tickets/${data.value}`"
            target="_blank"
          >
            #{{ data.value }}
          </b-link>
        </template>
        <!-- Column: tyyppi -->
        <template #cell(type)="data">
          <b-badge
            pill
            :variant="getVariant(data.value)"
          >
            <feather-icon
              :icon="getIcon(data.value)"
              class="mr-50"
            />
            {{ getTypeText(data.value) }}
          </b-badge>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="12"
            class="d-flex align-items-center justify-content-center justify-content-sm-center"
          >
            <b-button
              v-show="canLoadMore"
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              pill
              :disabled="loadMore"
              variant="outline-secondary"
              @click="onLoadMore"
            >
              <div v-if="loadMore">
                <b-spinner small />
                {{ $t('loading') }}
              </div>
              <div v-if="!loadMore">
                {{ $t('load_more') }}
              </div>

            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BButton, BCard, BRow, BCol, BTable, BSpinner, BLink, BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import useRequestList from './useRequestList'

export default {
  components: {
    BButton,
    BCard,
    BRow,
    BCol,
    BTable,
    BSpinner,
    BLink,
    BBadge,

    vSelect,
  },
  directives: {
    Ripple,
  },

  methods: {
    getTypeText(type) {
      switch (type) {
        case 'shifts_confirmation':
          return this.$t('shift_veried')
        case 'quick_shifts_confirmation':
          return this.$t('instant_pay_verified')
        default:
          return this.$t('shift_veried')
      }
    },
    getVariant(type) {
      switch (type) {
        case 'shifts_confirmation':
          return 'primary'
        case 'quick_shifts_confirmation':
          return 'info'
        default:
          return 'secondary'
      }
    },
    getIcon(type) {
      switch (type) {
        case 'shifts_confirmation':
          return 'UserCheckIcon'
        case 'quick_shifts_confirmation':
          return 'ZapIcon'
        default:
          return 'UserPlusIcon'
      }
    },
  },

  setup() {

    const {
      refRequestListTable,
      tableColumns,
      statusFilter,
      statusOptions,
      loadMore,
      canLoadMore,

      fetchRequests,
      onLoadMore,
    } = useRequestList()

    return {
      refRequestListTable,
      tableColumns,
      statusFilter,
      statusOptions,
      loadMore,
      canLoadMore,

      fetchRequests,
      onLoadMore,
    }
  },
}
</script>

<style lang="scss" scope>
.status-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>
